import React from "react";
import ImgBlock from "./imgBlock";
import { Container } from "react-bootstrap";
import classes from './imgBlock.module.css';

const ImgList = ({imgblocks, title}) => {
    return (
        <Container fluid="md">
            <h1>{title}</h1>
            <div className={classes.imgBox}>
                {imgblocks.map((imgblock, index) =>
                    <ImgBlock number={index +1} imgblock={imgblock} key={imgblock.id}/>
                )}
            </div>
        </Container>
    )
}

export default ImgList;